import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { BC_API } from 'OpsCenter/app.constants';

@Component({
  selector: 'app-reservation-report',
  template: require('./reservation-report.component.html'),
  styles: [require('./reservation-report.component.scss')],
})
export class ReservationReportComponent implements OnInit, OnDestroy {
  @Input() merchant: any;
  downloadLink: string;
  isLoading: boolean;
  private destroy$ = new Subject();

  constructor(private httpClient: HttpClient) {
  }

  ngOnInit(): void {

  }

  onDownloadReservationReport(): void {
    this.downloadLink = null;
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    const startDate = moment().format(BC_API.JUST_DATE_FORMAT);
    const endDate = moment().add(7, 'days').format(BC_API.JUST_DATE_FORMAT);
    this.httpClient.post(`bc-api/bc/merchants/${this.merchant.id}/reports/generate`, {
      'type': 'RESERVATIONS',
      'fields': ['id', 'salutation', 'firstName', 'lastName', 'gender', 'email', 'phone', 'notes', 'date', 'start', 'end', 'status', 'people', 'guestCode', 'table', 'areas', 'functionSheet', 'info', 'reservationNote', 'createdBy', 'createdDate', 'lastEditedBy', 'reservationCategory', 'reservationPhase', 'phone2', 'mobilePhone', 'type', 'cancellationFee'],
      'sortBy': 'date',
      'startTime': '00:00',
      'endTime': '23:59',
      'statuses': ['AUTOMATIC CONFIRMED', 'CONFIRMED', 'CHECK-OUT', 'AUTOMATIC CHECK-OUT', 'NOTIFICATION_REQUESTED', 'RECONFIRMED', 'NOTIFIED', 'CREATED', 'NO SHOW', 'MERCHANT CANCELED', 'REJECTED', 'CUSTOMER CANCELED', 'REVOKED'],
      'areas': [],
      'frequency': 'DAILY',
      'startDate': startDate,
      'endDate': endDate,
      'mimeType': 'XLS',
    }).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.downloadLink = data as string;
      this.isLoading = false;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/merchant-tools/reservation-report/reservation-report.component.ts